import { css, etiColors } from '@eti/styles';
import { breakpoints } from '@etg/wings';
export const screenReaderOnly = css`
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;
export const screenReaderAddOnStyles = css`
  font-size: 0.0625rem;
`;
export const inputClass = css`
  margin-top: 0.25rem;
  width: 100%;

  @media (min-width: 33.125em) {
    max-width: 65%;
  }

  @media (min-width: 48em) {
    max-width: 100%;
  }

  @media (min-width: 62em) {
    max-width: 100%;
  }
`;
export const singleChoiceOptionClass = css`
  width: 50%; /* For our pal IE11. */
`;
const singleChoiceSelectionYesClass = css`
  background-color: ${etiColors.confirmation.light};
`;
const singleChoiceSelectionNoClass = css`
  background-color: ${etiColors.critical.light};

  input:checked ~ .etiCustomRadio::after {
    background-color: ${etiColors.critical.solid};
  }
`;
const singleChoiceSelectionUnselectedClass = css`
  background-color: ${etiColors.white};
`;
export const getHighlightedButtonClass = (selectedValue, option) => {
  if (option === true) {
    return selectedValue === true ? singleChoiceSelectionYesClass : singleChoiceSelectionUnselectedClass;
  }
  if (option === false) {
    return selectedValue === false ? singleChoiceSelectionNoClass : singleChoiceSelectionUnselectedClass;
  }
  return null;
};
export const availabilityReadMoreGrid = css`
  display: grid;

  .text {
    grid-area: 2 / 1 / 3 / 2;
  }

  .children {
    display: grid;
    grid-area: 1 / 1 / 2 / 2;
    margin-bottom: 16px;
    padding-inline: 16px;
  }
`;
export const availablityProductCardGrid = css`
  grid-area: 5 / 2 / 6 / 3;
  width: auto;

  @media (min-width: ${breakpoints._768}) {
    margin-inline-start: 16px;
  }
`;
//# sourceMappingURL=styles.js.map